import { Action, createAction, handleActions } from "redux-actions";
import { queueMessage } from "~shared/snackbarsProvider/actions";
import {
  CoberturaAuto,
  CompaniaCoberturas,
  GetCoberturasResponse,
  NegocioActivo,
  PostCoberturaRequest,
} from "~api/types";
import { Services } from "./types";

export interface ListadoCoberturasState {
  descripcionCoberturas: GetCoberturasResponse | null;
  companiaSelected?: CompaniaCoberturas | null;
  failed: boolean;
}

const putDescripcionCoberturaInited = createAction(
  "MODIFICAR_DESCRIPCION_COBERTURAS_INITED",
  (data: PostCoberturaRequest) => data
);
const putDescripcionCoberturaCompleted = createAction(
  "MODIFICAR_DESCRIPCION_COBERTURAS_COMPLETED"
);
const putDescripcionCoberturaFailed = createAction(
  "MODIFICAR_DESCRIPCION_COBERTURAS_FAILED",
  (error: unknown) => ({ error })
);

const postDescripcionCoberturaInited = createAction(
  "AGREGAR_DESCRIPCION_COBERTURAS_INITED",
  (data: PostCoberturaRequest) => data
);
const postDescripcionCoberturaCompleted = createAction(
  "AGREGAR_DESCRIPCION_COBERTURAS_COMPLETED",
  (cobertura: PostCoberturaRequest) => ({ cobertura })
);
const postDescripcionCoberturaFailed = createAction(
  "AGREGAR_DESCRIPCION_COBERTURAS_FAILED",
  (error: unknown) => ({ error })
);

const getDescripcionCoberturaInited = createAction(
  "OBTENER_DESCRIPCION_COBERTURAS_INITED"
);
const getDescripcionCoberturaCompleted = createAction(
  "OBTENER_DESCRIPCION_COBERTURAS_COMPLETED",
  (descripcionCoberturas: GetCoberturasResponse) => ({ descripcionCoberturas })
);
const getDescripcionCoberturaFailed = createAction(
  "OBTENER_DESCRIPCION_COBERTURAS_FAILED",
  (error: unknown) => ({ error })
);

const updateDescripcionesCoberturas = createAction(
  "UPDATE_DESCRIPCION_COBERTURAS",
  (descripcionCoberturas: GetCoberturasResponse) => ({ descripcionCoberturas })
);

const setCompaniaSelected = createAction(
  "SET_COMPANIA_SELECTED",
  (companiaSelected: CompaniaCoberturas | null | undefined) => ({
    companiaSelected,
  })
);

const putDescripcionCobertura = (
  id: string,
  nombre: string,
  descripcion: string,
  tipoCobertura: string,
  compania: string,
  negocios: NegocioActivo[]
) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(
        putDescripcionCoberturaInited({
          id,
          nombre,
          descripcion,
          tipoCobertura,
          compania,
          negocios,
        })
      );

      const data = {
        id,
        nombre,
        descripcion,
        tipoCobertura,
        compania,
        negocios,
      };
      await services.api.coberturas().putCoberturas(data);

      dispatch(putDescripcionCoberturaCompleted());
    } catch (error) {
      console.error(error);
      dispatch(putDescripcionCoberturaFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al guardar los cambios. Intente nuevamente."
        )
      );
    }
  };
};

const postDescripcionCobertura = (
  id: string,
  nombre: string,
  descripcion: string,
  tipoCobertura: string,
  compania: string,
  negocios: NegocioActivo[]
) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(
        postDescripcionCoberturaInited({
          id,
          nombre,
          descripcion,
          tipoCobertura,
          compania,
          negocios,
        })
      );

      const data = {
        id,
        nombre,
        descripcion,
        tipoCobertura,
        compania,
        negocios,
      };

      const cobertura = await services.api.coberturas().postCoberturas(data);

      data.id = cobertura.id;
      dispatch(postDescripcionCoberturaCompleted(data));
    } catch (error) {
      console.error(error);
      dispatch(postDescripcionCoberturaFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al guardar los cambios. Intente nuevamente."
        )
      );
    }
  };
};

const listadoCoberturasInitialState: ListadoCoberturasState = {
  descripcionCoberturas: null,
  failed: false,
};

const listadoCoberturasReducer = handleActions<ListadoCoberturasState, any>(
  {
    [putDescripcionCoberturaInited.toString()]: (state) => {
      return {
        ...state,
      };
    },
    [putDescripcionCoberturaCompleted.toString()]: (state) => {
      return {
        ...state,
      };
    },
    [putDescripcionCoberturaFailed.toString()]: (state) => {
      return {
        ...state,
      };
    },
    [postDescripcionCoberturaInited.toString()]: (state) => {
      return {
        ...state,
      };
    },
    [postDescripcionCoberturaCompleted.toString()]: (
      state,
      action: Action<{ cobertura: PostCoberturaRequest }>
    ) => {
      const { compania, ...nuevaCobertura } = action.payload.cobertura;
      const index = state.descripcionCoberturas!.companias.findIndex(
        (x) => x.idCompania === compania
      );
      const descripcionCoberturas = { ...state.descripcionCoberturas! };
      // La cobertura recién creada no trae idExterno: el backend responde sin él.
      descripcionCoberturas.companias[index].coberturasAutos.push(
        nuevaCobertura as CoberturaAuto
      );

      return {
        ...state,
        descripcionCoberturas: descripcionCoberturas,
      };
    },
    [postDescripcionCoberturaFailed.toString()]: (state) => {
      return {
        ...state,
      };
    },
    [getDescripcionCoberturaInited.toString()]: (state) => {
      return {
        ...state,
      };
    },
    [getDescripcionCoberturaCompleted.toString()]: (
      state,
      action: Action<{ descripcionCoberturas: GetCoberturasResponse }>
    ) => {
      return {
        ...state,
        descripcionCoberturas: action.payload.descripcionCoberturas,
        companiaSelected: action.payload.descripcionCoberturas.companias[0],
        failed: false,
      };
    },
    [getDescripcionCoberturaFailed.toString()]: (state) => {
      return {
        ...state,
        failed: true,
      };
    },
    [updateDescripcionesCoberturas.toString()]: (
      state,
      action: Action<{ descripcionCoberturas: GetCoberturasResponse }>
    ) => {
      return {
        ...state,
        descripcionCoberturas: action.payload.descripcionCoberturas,
      };
    },
    [setCompaniaSelected.toString()]: (
      state,
      action: Action<{
        companiaSelected: CompaniaCoberturas | null | undefined;
      }>
    ) => {
      return {
        ...state,
        companiaSelected: action.payload.companiaSelected,
      };
    },
  },
  listadoCoberturasInitialState
);

const getDescripcionCobertura = () => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getDescripcionCoberturaInited());

      const response = await services.api.coberturas().getCoberturas({});

      dispatch(getDescripcionCoberturaCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getDescripcionCoberturaFailed(error));
    }
  };
};

export { listadoCoberturasReducer };
export {
  putDescripcionCobertura,
  postDescripcionCobertura,
  getDescripcionCobertura,
  updateDescripcionesCoberturas,
  setCompaniaSelected,
};
